import {useState, useEffect, useMemo} from 'react';
import Select from 'react-select';
import { useTheme } from '@mui/material';

const SelectValidPotCli = ({
    id,
    value,
    onChange,
    isInvalid,
    isClearable,
    disabled,
    defaultProps
}) => {
    const theme = useTheme();
    const isDarkMode = theme.palette.mode === 'dark';
    const [selectedValue, setSelectedValue] = useState(value);
    const onSelectValue = (ev) => {
        setSelectedValue(ev);
        onChange(ev);
    };
    const options = [
        {
            label: 'Nro Cuenta',
            value: 'contactoCuenta_con',
            tipo: 'texto'
        },
        {
            label: 'Nombre Completo',
            value: 'nombreContacto_con',
            tipo: 'texto'
        },
        {
            label: 'Plan de Consulta',
            value: 'planConsulta_con',
            tipo: 'select'
        },
        {
            label: 'Canal de comunicacion',
            value: 'canal_con',
            tipo: 'select'
        },
        {
            label: 'Segmento',
            value: 'segmento_con',
            tipo: 'select'
        },
        {
            label: 'Localidad',
            value: 'localidadId_con',
            tipo: 'select'
        },
        {
            label: 'Direccion',
            value: 'direccionConsulta_con',
            tipo: 'texto'
        },
        {
            label: 'Celular',
            value: 'celularConsulta_con',
            tipo: 'texto'
        },
        {
            label: 'Telefono',
            value: 'telefonoConsulta_con',
            tipo: 'texto'
        },
        {
            label: 'Nro Pre-Servicio',
            value: 'preServicioId_con',
            tipo: 'texto'
        },
        {
            label: 'Nro Servicio',
            value: 'cuentaServicioId_con',
            tipo: 'texto'
        },
        {
            label: 'Observacion',
            value: 'observaciones_con',
            tipo: 'texto'
        },
        {
            label: 'Estado',
            value: 'estadoConsulta_con',
            tipo: 'select'
        },
        {
            label: 'Sub-Estado',
            value: 'subEstadoConsulta_con',
            tipo: 'select'
        },
        {
            label: 'Bajada Máxima MB',
            value: 'bajadaMaxMb_con',
            tipo: 'texto'
        },
        {
            label: 'Creado Por',
            value: 'createdPersonaId_con',
            tipo: 'select'
        }
    ]

    useEffect(() => {
        if (typeof value === 'string') {
            setSelectedValue(options.find((opt) => opt.value === value));
        }
    }, [value]);
    const customStyles = useMemo(() => ({
        menuPortal: (base) => ({...base, zIndex: 9999}),
        menu: (provided) => ({
            ...provided,
            backgroundColor: isDarkMode ? '#2d3a52' : '#fff',
        }),
        option: (provided, state) => ({
            ...provided,
            color: state.isSelected ? '#fff' : isDarkMode ? '#fff' : '#000',
            background: state.isSelected ? '#0364ff' : isDarkMode ? '#2d3a52' : '#fff',
            '&:hover': {
                backgroundColor: '#02378c',
                color: '#fff',
            },
        }),
        multiValue: (styles, { data }) => {
            return {
                ...styles,
                backgroundColor: '#0364ff',
                borderRadius: 5
            };
        },
        multiValueLabel: (styles, { data }) => ({
            ...styles,
            color: '#fff',
            borderRadius: 5
        }),
        multiValueRemove: (styles, { data }) => ({
            ...styles,
            color: '#fff',
            borderRadius: 5,
            '&:hover': {
                backgroundColor: '#02378c',
                color: '#fff',
            },
        }),
        control: (styles) => ({
            ...styles,
            borderRadius: 7,
            borderColor: isDarkMode ? '#4a5568' : 'gray',
            backgroundColor: isDarkMode ? '#2d3a52' : '#fff',
        }),
        singleValue: (provided) => ({
            ...provided,
            color: isDarkMode ? '#fff' : '#000',
        }),
        input: (provided) => ({
            ...provided,
            color: isDarkMode ? '#fff' : '#000',
        }),
        placeholder: (provided) => ({
            ...provided,
            color: isDarkMode ? '#a0aec0' : '#999',
        }),
    }), [isDarkMode])
    return (
        <Select
            {...defaultProps}
            inputId={id}
            className={`react-select-container ${
                isInvalid ? 'is-invalid' : ''
            }`}
            styles={customStyles}
            menuPortalTarget={document.body}
            classNamePrefix="react-select"
            placeholder="Seleccione..."
            options={options}
            value={selectedValue}
            onChange={onSelectValue}
            isClearable={isClearable}
            isDisabled={disabled}
            menuShouldScrollIntoView
            menuPosition='absolute'
            menuPlacement='auto'
        />
    );
};

SelectValidPotCli.defaultProps = {
    isClearable: false,
    value: null
};

export default SelectValidPotCli;